/*
 * (c) Copyright Reserved EVRYTHNG Limited 2021. All rights reserved.
 * Use of this material is subject to license.
 * Copying and unauthorised use of this material strictly prohibited.
 */

/**
 * @returns {string}
 */
export default function getDefaultUrlFromQueryParams() {
  const { search: queryString } = window.location;
  return new URLSearchParams(queryString).get('defaultUrl') || '';
}
